import { useEffect } from "react";
import {
  FormLabel,
  StyledSelect,
  ProfilePaymentIcon,
  ProfilePaymentIcons,
} from "@components";
import { usePaymentProfilesContext } from "@context/PaymentProfilesContext";

export const PaymentProfileFormField = ({ control, setValue }) => {
  const { profiles: paymentProfiles } = usePaymentProfilesContext();

  useEffect(() => {
    if (paymentProfiles.length === 1) {
      setValue("paymentProfileId", paymentProfiles[0].id, {
        shouldValidate: false,
      });
    }
  }, [paymentProfiles, setValue]);

  if (paymentProfiles.length === 1) {
    return (
      <>
        <FormLabel>Payment profile</FormLabel>
        <p className="text-sm text-zinc-700 mt-1">{paymentProfiles[0].name}</p>
      </>
    );
  }

  return (
    <>
      <FormLabel>Payment profile</FormLabel>
      <StyledSelect
        name="paymentProfileId"
        control={control}
        displayName="Payment profile"
        options={[
          {
            key: "",
            label: { name: "Default payment profile", profile: null },
          },
          ...paymentProfiles.map((p) => ({
            key: p.id,
            label: { name: p.name, profile: p },
          })),
        ]}
        renderDisplay={({ name, profile }) => (
          <span className="flex items-center justify-between pr-1">
            <span className="text-zinc-600">{name}</span>
            {profile ? (
              <ProfilePaymentIcons profile={profile} size="sm" />
            ) : (
              <ProfilePaymentIcon paymentType="Default" size="sm" />
            )}
          </span>
        )}
        renderOptions={({ name, profile }, isSelected) => (
          <div className="flex justify-between items-center w-full">
            <span
              className={
                isSelected
                  ? "font-medium text-primary"
                  : "font-medium text-zinc-600"
              }
            >
              {name}
            </span>
            {profile ? (
              <ProfilePaymentIcons profile={profile} size="sm" />
            ) : (
              <ProfilePaymentIcon paymentType="Default" size="sm" />
            )}
          </div>
        )}
        width="full"
      />
    </>
  );
};
